module.exports = __webpack_public_path__ + "static/media/gethereum-mascot-circle.75cbd3a5.png";